import { CoreMeasure } from '@bepatient/core';
import { Action } from '@ngrx/store';

export enum TakeMeasureActionTypes {
  LOAD_MEASURES_LIST = '[TakeMeasure] Load measures list',
  LOAD_MEASURES_LIST_FAILED = '[TakeMeasure] Load measures list failed',
  LOAD_MEASURES_LIST_SUCCESS = '[TakeMeasure] Load measures list success',
  SAVE_MANUAL_MEASURE = '[TakeMeasure] Save manual measure',
  SAVE_MANUAL_MEASURE_FAILED = '[TakeMeasure] Save manual measure failed',
  SAVE_MANUAL_MEASURE_SUCCESS = '[TakeMeasure] Save manual measure success'
}

export class TakeMeasureActionLoadMeasuresList implements Action {
  readonly type = TakeMeasureActionTypes.LOAD_MEASURES_LIST;
}

export class TakeMeasureActionLoadMeasuresListFailed implements Action {
  readonly type = TakeMeasureActionTypes.LOAD_MEASURES_LIST_FAILED;
}

export class TakeMeasureActionLoadMeasuresListSuccess implements Action {
  readonly type = TakeMeasureActionTypes.LOAD_MEASURES_LIST_SUCCESS;
  constructor(public payload: Array<CoreMeasure>) {}
}

export class TakeMeasureActionSaveManualMeasure implements Action {
  readonly type = TakeMeasureActionTypes.SAVE_MANUAL_MEASURE;

  constructor(public payload: any) {}
}

export class TakeMeasureActionSaveManualMeasureFailed implements Action {
  readonly type = TakeMeasureActionTypes.SAVE_MANUAL_MEASURE_FAILED;
}

export class TakeMeasureActionSaveManualMeasureSuccess implements Action {
  readonly type = TakeMeasureActionTypes.SAVE_MANUAL_MEASURE_SUCCESS;
}

export type TakeMeasureActions =
  | TakeMeasureActionLoadMeasuresList
  | TakeMeasureActionLoadMeasuresListFailed
  | TakeMeasureActionLoadMeasuresListSuccess
  | TakeMeasureActionSaveManualMeasure
  | TakeMeasureActionSaveManualMeasureSuccess
  | TakeMeasureActionSaveManualMeasureFailed;
